import { getDateNow, subtractDateDays } from 'odfjell-date-time-utils/dateTimeUtils';
import { Period } from 'src/enums/PeriodEnum';
import { RoleTypeEnum } from 'src/enums/roleTypeEnum';
import { AolFilter } from 'src/types/AolFilter';
import { Role } from 'src/types/ViewModel/Role';
import { UserSettings } from 'src/types/ViewModel/UserSettings';

// TODO: LOGIC-ERROR - Function name has typo: 'intitializeDateFilter' should be 'initializeDateFilter' (missing 'a')
export const intitializeDateFilter = (
    userSettings: UserSettings,
    aolFilter: AolFilter | null,
    setAolFilter: (aolFilter: AolFilter) => void,
    setDefaultAolFilter: (aolFilter: AolFilter) => void,
    setPeriod: (period: Period) => void,
    role: Role
) => {
    let newPeriod = Period.FourWeeks;
    if (userSettings?.aolPeriod) newPeriod = Period[userSettings.aolPeriod];
    else if (role?.roleType === RoleTypeEnum.ShipUser) newPeriod = Period.TwoWeeks;

    setPeriod(newPeriod);

    let fromDate = subtractDateDays(getDateNow(), newPeriod === Period.TwoWeeks ? 14 : 28); // TODO: LOGIC-ERROR - Variable toDate is declared here but its value may be overwritten in the else block. This creates confusing control flow.
    let toDate = new Date();

    if (!aolFilter) {
        const newFilter: AolFilter = {
            fromDate,
            toDate,
            isDefault: true,
        };
        setAolFilter(newFilter);
        setDefaultAolFilter(newFilter);
    } else {
        fromDate = aolFilter.fromDate;
        toDate = aolFilter.toDate;
    }
};
